<div class="header__wrapper">
  <div class="header__upper">
    <a class="header--left">
      <a (click)="navigateBack()" *ngIf="showNavBackButton">
        <img class="navigate-back" alt="menu logo" src="{{ ARROW_LEFT_WHITE }}" />
      </a>
      <img (click)="navigateToHome()" alt="menu logo" src="{{ LOGO }}" class="img__logo" />
    </a>
    <div class="header--right">
      <div class="coin-balance" id="coinBalanceDiv">
        <img src="{{ MBC_FRONT_SIDE }}" alt="" class="mbc-coin" />
        <div class="coins__number--wrapper">
          <p id="coinsBalanceText" class="coins__number">
            {{ $mbcBalance | async | number: '1.0-0' : 'de-DE' }}
          </p>
        </div>
      </div>
      <div
        *ngIf="!headerService.isNotificationPageVisible()"
        class="notification-wrapper"
        (click)="navigateToNotifications()"
        [ngClass]="{ shake: (($unreadCount | async) ?? '0') > '0' }"
      >
        <img src="{{ NOTIFICATION_BELL }}" alt="Notifications" class="notification-bell" />
        <span class="notification-count" *ngIf="(($unreadCount | async) ?? '0') > '0'">{{
          $unreadCount | async
        }}</span>
      </div>
    </div>
  </div>
  <div class="header" *ngIf="headerService.currentNavBar" [className]="'header'">
    <div class="header-icon-wrapper">
      @if (headerService.currentNavBar.imageURL) {
        <img src="{{ headerService.currentNavBar.imageURL }}" class="header-icon" />
      }
      {{ headerService.currentNavBar.title }}
    </div>
    <button
      class="btn header-info"
      (click)="openInfoModal()"
      *ngIf="headerService.currentNavBar.hasInfo"
    >
      <img alt="info Logo" class="header-info-img" src="{{ INFO_WHITE }}" />
    </button>
  </div>
</div>
